import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserSearchCriteria} from 'web-angular-client';
import {SearchService} from '../../../sdk/component/search/search.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {UserSearchCriteriaImpl} from '../../../sdk/component/search/user-search-criteria';
import {SearchFilterBase} from '../../../sdk/component/search/search-filter-base';
import {DropdownItem} from '../../../sdk/interface/data/DropdownItem';
import {FilterPersistenceService} from '../../../sdk/component/search/filter-persistence.service';
import {ActivatedRoute} from '@angular/router';
import UserStatusEnum = UserSearchCriteria.UserStatusEnum;

@Component({
    selector: 'app-user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.scss'],
    standalone: false
})
export class UserSearchComponent extends SearchFilterBase implements OnInit, OnDestroy
{
    form: UntypedFormGroup;
    private NAME: string = 'name';
    private SURNAME: string = 'surname';
    private MOBILE: string = 'mobile';
    private EMAIL: string = 'email';
    private ROLE: string = 'role';
    private USER_STATUS: string = 'userStatus';
    private FIRST_NAME = 'firstName';
    private LASTNAME = 'lastName';
    private EMAIL_ADDRESS = 'emailAddress';
    private MOBILE_NO = 'mobileNo';
    private USER_ROLE = 'userRole';
    private STATUS = 'status';
    private userSearchCriteria: UserSearchCriteria = new UserSearchCriteriaImpl();

    constructor(
        protected searchDataService: SearchService,
        protected filterPersistenceService: FilterPersistenceService,
        protected route: ActivatedRoute,
        private formBuilder: UntypedFormBuilder,
        protected ngxLoader: NgxUiLoaderService)
    {
        super(searchDataService, ngxLoader, filterPersistenceService, route);
    }

    get activeTab(): string
    {
        return this._activeTab;
    }

    get tabActive(): boolean
    {
        return !!this.activeTab;
    }

    get roleOptions(): DropdownItem[]
    {
        return [
            'Any',
            'Super Administrator',
            'Administrator',
            'Guest Administrator',
            'Field Agent'
        ].map(role => ({label: role, value: role}));
    }

    get statusOptions(): DropdownItem[]
    {
        return [
            'ANY',
            'ACTIVE',
            'INACTIVE'
        ].map(status => ({label: status, value: status}));
    }

    get displayStatus(): string
    {
        return this.userSearchCriteria.userStatus.valueOf();
    }

    ngOnInit(): void
    {
        this.form = this.formBuilder.group({
            email: [''],
            name: [''],
            surname: ['', Validators.email],
            mobile: ['', Validators.maxLength(10)],
            role: ['Any'],
            userStatus: [UserStatusEnum.ANY]
        });

        this.initializeSearchPage();
    }

    ngOnDestroy(): void
    {
        clearInterval(this.interval);
    }

    setSearchCriteria(event: any)
    {
        let inputId = event.target.id;
        let val = event.target.value;
        this.setUserSearchCriteria(inputId, val);
    }

    getSearchCriteria(): any
    {
        return this.userSearchCriteria;
    }

    setUserSearchCriteria(id: string, val: any)
    {
        switch (id)
        {
            case this.NAME:
                this.userSearchCriteria.name = <string> val;
                break;
            case this.SURNAME:
                this.userSearchCriteria.surname = <string> val;
                break;
            case this.MOBILE:
                this.userSearchCriteria.mobile = <string> val;
                break;
            case this.EMAIL:
                this.userSearchCriteria.email = <string> val;
                break;
        }
    }

    getTabContent(event: any)
    {
        this._activeTab = event.target.id.toString();
        this.saveCurrentFilters();
    }

    clear(activeTab: string)
    {
        switch (activeTab)
        {
            case this.FIRST_NAME:
                this.userSearchCriteria.name = null;
                this.form.get(this.NAME).reset();
                break;
            case this.LASTNAME:
                this.userSearchCriteria.surname = null;
                this.form.get(this.SURNAME).reset();
                break;
            case this.EMAIL_ADDRESS:
                this.userSearchCriteria.email = null;
                this.form.get(this.EMAIL).reset();
                break;
            case this.MOBILE_NO:
                this.userSearchCriteria.mobile = null;
                this.form.get(this.MOBILE).reset();
                break;
            case this.USER_ROLE:
                this.userSearchCriteria.role = null;
                this.form.get(this.ROLE).reset('Any');
                break;
            case this.STATUS:
                this.userSearchCriteria.userStatus = UserStatusEnum.ANY;
                this.form.get(this.USER_STATUS).reset(UserStatusEnum.ANY);
                break;
        }

        this.search();
    }

    clearAll()
    {
        this.userSearchCriteria = new UserSearchCriteriaImpl();
        this.form.reset(this.userSearchCriteria);
        this.form.get(this.ROLE).reset('Any');
        this.search();
    }

    disableClearAll(): boolean
    {
        return !this.form.dirty;
    }

    disableClear(activeTab: string): boolean
    {
        switch (activeTab)
        {
            case this.FIRST_NAME:
                return !this.form.get(this.NAME).dirty;
            case this.LASTNAME:
                return !this.form.get(this.SURNAME).dirty;
            case this.EMAIL_ADDRESS:
                return !this.form.get(this.EMAIL).dirty;
            case this.MOBILE_NO:
                return !this.form.get(this.MOBILE).dirty;
            case this.USER_ROLE:
                return !this.form.get(this.ROLE).dirty;
            case this.STATUS:
                return !this.form.get(this.USER_STATUS).dirty;
            default:
                return true;
        }
    }

    setFilters(): void
    {
        this.applyFilters(
            this.form,
            (criteria: UserSearchCriteria) => this.userSearchCriteria = criteria,
            null
        );
    }
}